import classNames from 'classnames'

import { CardSection } from 'shared/components/CardSection'
import Icon from 'shared/components/Icon'
import { RateCurrency } from 'shared/price-utilities'

import { AdditionalBenefits } from './AdditionalBenefits'

import styles from '../styles.module.scss'

export const ProductCardSection = ({ index, rate, activeSelectedRate, onClickHandler }) => {
    const defaultRateImageUrl = rate.images.length > 0 && rate.images.find(image => image.isDefault)

    const showHeadlineRateAmount = rate.headlineRateAmount > rate.amount

    return (
        <CardSection
            key={index}
            activeSelected={activeSelectedRate(rate)}
            notActive
            className={classNames('px-3', 'py-3', 'mt-3', styles.cardSection, rate.soldOut && styles.disabled)}>
            <button
                className={classNames('d-flex w-100', styles.cardButton)}
                onClick={() => {
                    onClickHandler(rate)
                }}>
                {defaultRateImageUrl && (
                    <div className={styles.rateImage}>
                        <img src={defaultRateImageUrl?.url} alt={defaultRateImageUrl?.name} />
                    </div>
                )}
                <div className={classNames(styles.textContextWrap, defaultRateImageUrl && styles.setWidth)}>
                    <div className={classNames('d-flex', 'flex-column', styles.rateDescriptionWrap)}>
                        <div className={styles.titleRow}>
                            <span className={styles.rateName}>{rate.rateName}</span>
                            <div className={styles.productRatesAmountWrap}>
                                <div>
                                    {showHeadlineRateAmount && (
                                        <span className={styles.headlineAmount}>
                                            <RateCurrency rate={rate} value={rate.headlineRateAmount} />
                                        </span>
                                    )}
                                    <span className={styles.rateAmount}>
                                        <RateCurrency rate={rate} value={rate.amount} />
                                    </span>
                                </div>
                                {rate.soldOut && (
                                    <div className={styles.soldOutLabelContainer}>
                                        <Icon type="alert" size="xs" className="mb-3 mr-2" />
                                        <span>
                                            <T>booking.product.sold.out</T>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <span className={classNames('text-light text-small', styles.shortDescription)}>
                            {rate.shortDescription}
                        </span>

                        <AdditionalBenefits images={rate.rateIcons} />
                    </div>
                </div>
            </button>
        </CardSection>
    )
}
